import Props from "../../../../../docs/components/props.js";
import * as React from 'react';
export default {
  Props,
  React
};